import React from 'react'
import { Icon, IconType } from '@pandiafi/design-system'

import { ComingSoonBadge } from 'components/ComingSoonBadge/ComingSoonBadge'

export interface LinkLabelProps {
  label: string
  icon?: string
  hint?: string
}

export const LinkLabel: React.FC<LinkLabelProps> = ({ label, icon, hint }) => {
  return (
    <>
      {hint && (
        <div className="absolute -top-2.5 right-0 opacity-100 z-40">
          <ComingSoonBadge label={hint} />
        </div>
      )}

      <div data-content="main">
        {icon && (
          <div className="mb-3 flex justify-center">
            <div className="size-14 rounded-full p-0.5 bg-common-gray-3 flex items-center justify-center">
              <Icon
                icon={icon as IconType}
                size="2x"
                className="text-brand-6"
              />
            </div>
          </div>
        )}

        <span className="font-normal text-sm text-center block text-brand-6">
          {label}
        </span>
      </div>
    </>
  )
}
